import { RowSelectionState } from '@tanstack/react-table';
import { useCallback, useMemo, useState } from 'react';

const useControlledRowSelection = ([rowSelection, setRowSelection]: [
    RowSelectionState,
    React.Dispatch<React.SetStateAction<RowSelectionState>>,
]) => {
    const resetRowSelection = useCallback(() => {
        setRowSelection({});
    }, [setRowSelection]);

    return useMemo(() => {
        const selectedRowsIds = Object.keys(rowSelection);
        const selectedRowsCount = selectedRowsIds.length;
        const hasRowsSelected = selectedRowsCount > 0;

        return {
            rowSelection,
            setRowSelection,
            selectedRowsIds,
            selectedRowsCount,
            hasRowsSelected,
            unselectRow: (id: string) => {
                setRowSelection(({ [id]: removed, ...rows }) => rows);
            },
            resetRowSelection,
        };
    }, [resetRowSelection, rowSelection, setRowSelection]);
};

export const useRowSelection = () => {
    const [rowSelection, setRowSelection] = useState<RowSelectionState>({});
    return useControlledRowSelection([rowSelection, setRowSelection]);
};
